module.exports = __webpack_public_path__ + "static/media/Akkurat-Bold.0ec641a9.woff2";